import { makeActions } from '@redux/crudCreator/actions';
import { PRIMARY_KEY } from '@redux/crudCreator/dataProvider';
import { apiWrapper } from '@redux/crudCreator/reduxUtils';
import {
  CreatePayloadType,
  EditPayloadType,
  GetAllPayloadType,
} from '@redux/crudCreator/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  cancelApi,
  commentReturnApi,
  failedQCApi,
  passQCApi,
  approvedApi,
  paymentRefundApi,
  validationChecklistApi,
  completeReturnApi,
  markAsSuccessApi,
  markAsReceivedApi,
} from 'api/returnOrders';

export const MODEL_NAME = 'ordersReturn';
export const ordersReturnActions = makeActions(
  MODEL_NAME,
  'id',
  'return-orders',
);

export const getAllOrdersReturn = ordersReturnActions.getAll;
export const editOrdersReturn = ordersReturnActions.edit;
export const createOrdersReturn = ordersReturnActions.create;
export const getByIdOrdersReturn = ordersReturnActions.getDataById;

export const returnComment = createAsyncThunk(
  'auth/returnComment',
  async (payload: CreatePayloadType, thunkAPI) => {
    try {
      const response = await apiWrapper(null, commentReturnApi, payload?.data);
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const approvedOrderReturn = createAsyncThunk(
  'ordersReturn/approvedOrderReturn',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true, ...options },
        approvedApi,
        data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const cancelOrderReturn = createAsyncThunk(
  'ordersReturn/cancelOrderReturn',
  async (payload: EditPayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true, ...options },
        cancelApi,
        data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const passQCOrderReturn = createAsyncThunk(
  'ordersReturn/passQCOrderReturn',
  async (payload: EditPayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true, ...options },
        passQCApi,
        data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const failedQCReturn = createAsyncThunk(
  'ordersReturn/failedQCReturn',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true, ...options },
        failedQCApi,
        data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const paymentRefund = createAsyncThunk(
  'ordersReturn/paymentRefund',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true, ...options },
        paymentRefundApi,
        data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const validationChecklist = createAsyncThunk(
  'ordersReturn/validationChecklist',
  async (payload: GetAllPayloadType, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(
        null,
        validationChecklistApi,
        data[PRIMARY_KEY],
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);

export const completeReturn = createAsyncThunk(
  'ordersReturn/completeReturn',
  async (payload: GetAllPayloadType, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(
        null,
        completeReturnApi,
        data[PRIMARY_KEY],
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);

export const markAsSuccess = createAsyncThunk(
  'ordersReturn/markAsSuccess',
  async (payload: EditPayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true, ...options },
        markAsSuccessApi,
        data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const markAsReceived = createAsyncThunk(
  'ordersReturn/markAsReceived',
  async (payload: EditPayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true, ...options },
        markAsReceivedApi,
        data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);
